const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user_data';

/**
 * Set authentication token in localStorage
 * @param {string} token - JWT or auth token
 */
export const setAuthToken = (token) => {
  if (token && token !== 'undefined' && token !== 'null') {
    localStorage.setItem(TOKEN_KEY, token);
    console.log("Token set in localStorage:", !!token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
    console.log("Invalid token, removing from localStorage");
  }
};

/**
 * Get authentication token from localStorage
 * @returns {string|null} - Auth token or null
 */
export const getAuthToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  // Handle case where 'undefined' string is stored
  if (token === 'undefined' || token === 'null') {
    return null;
  }
  return token;
};

/**
 * Set user data in localStorage
 * @param {Object} userData - User information object
 */
export const setUserData = (userData) => {
  if (userData && userData !== undefined) {
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    console.log("User data set in localStorage:", userData);
  } else {
    localStorage.removeItem(USER_KEY);
    console.log("User data is undefined, removing from localStorage");
  }
};

/**
 * Get user data from localStorage
 * @returns {Object|null} - User data object or null
 */
export const getUserData = () => {
  try {
    const userData = localStorage.getItem(USER_KEY);
    console.log('Getting user data from localStorage:', !!userData);
    if (userData && userData !== 'undefined') {
      console.log('Parsed user data:', JSON.parse(userData));
      return JSON.parse(userData);
    }
    return null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    localStorage.removeItem(USER_KEY);
    return null;
  }
};

/**
 * Clear all authentication data from localStorage
 */
export const clearAuthData = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

/**
 * Get user ID from stored user data
 * @returns {number|null} - User ID or null
 */
export const getOuId = () => {
  const userData = getUserData();
  return userData?.organization_unit.org_id || null;
};

export const getCustomerId = () => {
  const userData = getUserData();
  return userData?.customer?.id || null;
};

/**
 * Get user ID from stored user data
 * @returns {number|null} - User ID or null
 */
export const getUserId = () => {
  const userData = getUserData();
  return userData?.user_id || null;
};

/**
 * Check if user is authenticated
 * @returns {boolean} - True if token exists, false otherwise
 */
export const isAuthenticated = () => {
  return !!getAuthToken();
};